Vue.component('select-stripe-plans', require('./SelectStripePlans').default);
Vue.component('subscribe-plans', require('./SubscribePlans').default);
Vue.component('update-subscription', require('./UpdateSubscription').default);
Vue.component('resume-subscription', require('./ResumeSubscription').default);
